import Vue from 'vue'
import App from './App.vue'

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCzSzJIl2jlCg8T_ucR3V0WdazDt9W8ZRY'
  }
})

// load event bus before app as the event bus is used in the app
export const eventBus = new Vue();

new Vue({
  el: '#app',
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js